import(/* webpackMode: "eager" */ "/home/ubuntu/website/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/website/public/studentWelfarePage/heroImage.webp");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/website/src/components/AboutPageComponents/StudentWelfarePage/CounsellingServices/CounsellingServices.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/website/src/components/AboutPageComponents/StudentWelfarePage/EventsSection/EventsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/website/src/components/AboutPageComponents/StudentWelfarePage/Facilities/Facilities.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/website/src/components/AboutPageComponents/StudentWelfarePage/FunctionDepartment/FunctionDepartment.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/website/src/components/Common/FooterCard/FooterCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/website/src/components/Common/VideoPlayer/VideoPlayer.tsx");
